import { apiClient, apiWrapper } from './api';
import { SupportIssueRequest, SupportIssueResponse } from '../types';

export const supportService = {
  // Create support issue
  async createIssue(data: SupportIssueRequest): Promise<SupportIssueResponse> {
    return apiWrapper(() =>
      apiClient.post<SupportIssueResponse>('/support/create-issue', data)
    );
  },
};
